import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import Down from "../../../assets/icon/NewsIcons/MainAdmin/NewsDown3"
import React, { useState, useEffect } from "react";

const MainAdminNewsesTopDropDown = ({mainText,items,mainTextSize,set,all,setLabel}) => {
    console.log(items?items[0]:null);
    
    return (
        <Menu as="div" className="relative inline-block text-left w-full h-[40px]">
          <div>
            <MenuButton className="h-[40px] flex justify-between items-center  w-full rounded-md px-3 py-2">
              {mainTextSize==15 ?<p className="text-mainColor2 text-[15px] font-IRANYekanBold">{mainText}</p> : null}
              {mainTextSize==12 ?<p className="text-mainColor2 text-[12px] font-IRANYekanBold">{mainText}</p> : null}
                
                <div><Down/></div>
              
              {/* <ChevronDownIcon aria-hidden="true" className="-mr-1 h-5 w-5 text-gray-400" /> */}
            </MenuButton>
          </div>
          <MenuItems
          transition
          className="absolute right-0 z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
    {
        items && all!=true?
        items.map((item)=>{
          return(
            <div className="py-1 flex flex-col items-start">
              <MenuItem>
                <button
                 onClick={()=>{set(item.value);setLabel(item.label)}}
                  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                >
                  <p className="font-IRANYekanNormal text-[15px]" >{item.label}</p>
                </button>
              </MenuItem>
           
            </div>
        )})
        :
        items && all==true?
        items.map((item)=>{
          return(
            <div className="py-1 flex flex-col items-start">
              <MenuItem>
                <button
                 onClick={()=>{item.set(true);setLabel(item.label)}}
                  className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                >
                  <p className="font-IRANYekanNormal text-[15px]" >{item.label}</p>
                </button>
              </MenuItem>
           
            </div>
        )})
        :
        null
      }
      </MenuItems>
       
        </Menu>
      )
}

export default MainAdminNewsesTopDropDown;